/**
 * App Store + Google Play listing copy — generated content the kennel
 * owner pastes into App Store Connect and Google Play Console at
 * submission time. Each block has its own character-budget readout and
 * a copy-to-clipboard button.
 *
 * Why this lives in its own file: it's "data," not a page. AdminMobileLaunch
 * imports it and renders. Keeping it here means the kennel owner can also
 * link to it from a marketing-ops doc later.
 */
export const STORE_LISTING = {
  app_name: {
    label: "App name",
    apple_limit: 30,
    google_limit: 30,
    value: "Armstrong K9 Registry",
  },
  subtitle: {
    label: "Subtitle (Apple) / Short description (Google)",
    apple_limit: 30,
    google_limit: 80,
    value: "Pedigree. Passion. Purpose.",
  },
  promotional_text: {
    label: "Promotional text (Apple — editable any time, no resubmit)",
    apple_limit: 170,
    google_limit: null,
    value:
      "Verified breeders. Audited pedigrees. Escrow-backed sales. Every dog pro in one trusted registry — buyers, breeders, trainers, vets, sitters, and transporters.",
  },
  keywords: {
    label: "Keywords (Apple only, comma-separated, 100 chars total)",
    apple_limit: 100,
    google_limit: null,
    value:
      "dog registry,pedigree,kennel,breeder,puppies,dog marketplace,bloodline,COI,exotic breed,K9",
  },
  description: {
    label: "Description (Apple + Google, 4000 chars)",
    apple_limit: 4000,
    google_limit: 4000,
    value: `Pedigree. Passion. Purpose.

Armstrong K9 Registry is the uncompromising standard for purebred and exotic dogs — the one platform where every serious dog person transacts, on a single set of receipts.

WHAT YOU GET

• A verified marketplace of puppies and grown dogs from kennels we hand-audit
• Six-generation pedigree views with COI (inbreeding) warnings flagged at registration
• Escrow-backed purchases that only release when the dog actually arrives
• A directory of verified trainers, groomers, walkers, sitters, and USDA-licensed transporters
• Live messaging with breeders and service providers — no email tag, no handshake deals
• Litter announcements with health-tested parents and full lineage on day one
• Your own free Dog Log to track meals, walks, weights, vet visits, and milestones — shareable with sitters and vets in one tap
• Heat-cycle and breeding tracker for working kennels
• An events calendar for shows, meetups, and breed gatherings near you

WHO IT'S FOR

→ Buyers searching for a verified breeder of a specific bloodline or rare breed
→ Breeders running a working kennel who want clean records, real reviews, and audited transactions
→ Service pros — trainers, vets, groomers, sitters, transporters — looking for premium clientele
→ Dog parents who just love their dog and want one place to keep everything organized

WHY ARMSTRONG

We are an independent registry. We do not hold international funds. We do not facilitate handshake deals. Every transaction is verified, escrowed, and reviewed by real owners. Six-generation pedigree depth is the only reliable way to surface inbreeding risk before a litter is on the ground — and it's the baseline for every dog in our system.

If you love dogs, this is the platform built for that love.

—

PAYMENTS &amp; APP STORE NOTICE

Physical products (dog food, merch, branded gear) and services (transport, training, vet visits, grooming) are paid via Stripe Checkout and shipped to your address or scheduled to your calendar — these are NOT in-app purchases. Subscription plans (Pro, Kennel Elite, Buyer Pass) are managed on our website at armstrongk9registry.com/billing per Apple's reader-app guideline 3.1.3(a). No in-app purchases are offered.

Questions: registry@armstrongk9registry.com
Privacy: armstrongk9registry.com/privacy
Terms: armstrongk9registry.com/terms
Account deletion: armstrongk9registry.com/account/delete`,
  },
  whats_new: {
    label: "What's New (initial release notes — Apple + Google)",
    apple_limit: 4000,
    google_limit: 500,
    value: `Welcome to Armstrong K9 Registry — Pedigree. Passion. Purpose.

This first release brings the full registry experience to your iPhone:
• Six-generation pedigree views
• Verified breeder marketplace with escrow-backed purchases
• Direct messaging with breeders and service pros
• Dog Log for meals, walks, weights, and vet records
• Heat-cycle tracker for working kennels
• Push notifications for inquiries, intros, and reminders

We're building this for breeders, buyers, and the professionals who serve them. Tell us what's missing: registry@armstrongk9registry.com`,
  },
};

/** Helper — returns "172 / 4000" style for the character-budget readout. */
export function budgetLabel(text, limit) {
  if (!limit) return null;
  const used = (text || "").length;
  const over = used > limit;
  return { used, limit, over, label: `${used} / ${limit}${over ? " — OVER" : ""}` };
}
